window.textNotification = async function() {
    if (('serviceWorker' in navigator) === false) {
        return;
    }

    if (('PushManager' in window) === false) {
        return;
    }

    if (('Notification' in window) === false) {
        return;
    }

    const registration = await navigator.serviceWorker.register('/build/assets/sw.js');

    const permission = await Notification.requestPermission();

    if (permission !== 'granted') {
        return;
    }

    const vapidPublicKey = import.meta.env.VITE_VAPID_PUBLIC_KEY;

    const subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(vapidPublicKey)
    });

    fetch('/push-notification', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': document.head.querySelector('meta[name=csrf-token]').content,
        },
        body: JSON.stringify(subscription),
    });
}

function urlBase64ToUint8Array(base64String) {
    const padding = "=".repeat((4 - (base64String?.length % 4)) % 4);
    const base64 = (base64String + padding)
        .replace(/\-/g, "+")
        .replace(/_/g, "/");

  const rawData = atob(base64);

  return Uint8Array.from([...rawData].map(char => char.charCodeAt(0)));
}